import React, { useEffect, useState } from "react";
import { SignInBaseForm, SignInMultiOptions } from "../components/user";
import { useToasts } from "react-toast-notifications";
import { authService } from "../../base/services";
import { isNilOrEmpty } from "src/main_app/utils/common";
import queryString from "query-string";

import { track, identifyUser } from "src/main_app/mixpanel";

import("./sign-in-style.scss");

export const SignInContext = React.createContext();

// The API answers with a string, a list of { message } (validation and
// responseAsError), or nothing at all on a crash or network error.
const toErrorText = (message) => {
  if (typeof message === "string" && message) return message;
  if (Array.isArray(message) && message.length) {
    return message.map((m) => m?.message || m).join(". ");
  }
  return "Please try again.";
};

const SignInPage = (props) => {
  const [loading, setLoading] = useState(false);
  const [afterLogin, setAfterLogin] = useState({ status: "idle" });
  const { addToast } = useToasts();

  useEffect(() => {
    if (afterLogin?.status === "ok") {
      addToast("Login successful", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });

      authService.authenticate({
        account: afterLogin.data.result.user,
        accessToken: afterLogin.data.result.token,
        tenant_info: afterLogin.data.result.tenant_info,
      });

      // identifyUser() registers the tenant/user super properties first, so the
      // event below already carries them.
      identifyUser();
      track("Login success", {
        method: afterLogin.method || null,
        role: afterLogin.data?.result?.user?.role,
      });

      const { url = "/" } = queryString.parse(location.search);
      const customer_id = afterLogin.data.customer;

      setTimeout(() => {
        document.location.href = 
          props.tenantConfig.pathLandingPage 
          ? props.tenantConfig.pathLandingPage 
          : afterLogin.data.customer && props.tenantConfig.slug !== "intellihub"
          ? `customer/${customer_id}/overview`
           : afterLogin.data.customer && props.tenantConfig.slug === "intellihub"
          ? `customer/${customer_id}/usage`
          : isNilOrEmpty(url) || /undefined/.test(url)
          ? "/"
          : url;
      }, 1500);
    }

    if (afterLogin?.status === "failed") {
      // The API sends its own "Login failed" (source: "api") with the exact
      // reason and IP; this one covers what only the browser sees, such as
      // network errors and requests that never reached the API.
      track("Login failed", {
        source: "web",
        method: afterLogin.method || null,
        reason: afterLogin.reason || null,
        http_status: afterLogin.httpStatus ?? null,
        message: afterLogin.message || null,
        email: afterLogin.email || null,
      });

      addToast(`Login failed. ${toErrorText(afterLogin?.message)}`, {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 10000,
      });
    }
  }, [afterLogin]);

  const defaultContextValue = {
    loading,
    afterLogin,
    setLoading,
    setAfterLogin,
  };

  return (
    <div className="col-sm-6 sign-in__body">
      <h1>Sign in to your account</h1>
      {loading && <div className="sign-in__loading-overlay"></div>}
      <SignInContext.Provider value={defaultContextValue}>
        {props.tenantConfig?.loginOptions && (
          <SignInMultiOptions tenantConfig={props.tenantConfig} />
        )}
      </SignInContext.Provider>
    </div>
  );
};

export default SignInPage;
